export const setTextVariantStyle = (variant, propertyName) => {
    let fontStyle = `
        font-style: normal;
        font-family: Noto Sans TC, Roboto, Helvetica, Arial, sans-serif;
    `;

    function getPropertyValueFromString(cssString, propertyName) {
        const pattern = new RegExp(`${propertyName}:\\s*([^;]+);`);
        const match = cssString.match(pattern);

        if (match && match.length === 2) {
            return match[1].trim();
        } else {
            return null;
        }
    }

    switch (variant) {
        case 'h1':
            fontStyle += `
                font-size: 96px;
                font-weight: 500;
                line-height: 1.3;
                letter-spacing: 0px;
            `;
            break;
        case 'h2':
            fontStyle += `
                font-size: 60px
                font-weight: 500;
                line-height: 1.3;
                letter-spacing: 0px;
            `;
            break;
        case 'h3':
            fontStyle += `
                font-size: 48px;
                font-weight: 500;
                line-height: 1.3;                
                letter-spacing: 0px;
            `;
            break;
        case 'h4':
            fontStyle += `
                font-size: 34px;
                font-weight: 400;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'h5':
            fontStyle += `
                font-size: 24px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'h6':
            fontStyle += `
                font-size: 20px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'subtitle1':
            fontStyle += `
                font-size: 16px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'subtitle2':
            fontStyle += `
                font-size: 14px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'body1':
            fontStyle += `
                font-size: 16px;
                font-weight: 400;
                line-height: 1.5;
                letter-spacing: 0.5px;
            `;
            break;
        case 'body2':
            fontStyle += `
                font-size: 14px;
                font-weight: 400;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'button':
            fontStyle += `
                font-size: 14px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'caption':
            fontStyle += `
                font-size: 12px;
                font-weight: 400;
                line-height: 1.5
                letter-spacing: 0px;
            `;
            break;
        case 'overline':
            fontStyle += `
                font-size: 10px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        default:
    }
    if (propertyName) {
        return getPropertyValueFromString(fontStyle, propertyName).replace(/px/, '');
    }
    return fontStyle;
};
